// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3USoE","footer":"ChangeClinic_footer__2RwVW"};